import ERRORS from '@/constants/errorsObito'

class ErrorsObitoHelper {
  static errosObito (val) {
    if (!val) return

    /**
     * Procuramos as palavras que estão na constant na string recebida e caso
     * seja encontrada a alteramos para sua esquivalente definida na constante
     */
    ERRORS.map(res => {
      val = val.replace(res.name, res.value)
    })

    // Mudamos o : de posição para a ja preparar o titulo do erro
    val = val.replace(/\ :/g,': ')

    // Alteramos palavra errada recebida errada da api
    val = val.replace(/\inviando/g, 'enviando')

    // Divimos o array em titulo e erros a partir dos :
    let arr1 = val.split(':')

    // Recolocamos o : no titulo
    arr1 = arr1.map(item => {
      return item.replace(/\erros/g, 'erros:')
    })

    // Fazemos um novo array apenas com os erros e removemos os erros do 1º array
    let arr2 = arr1[1].split('|')
    arr1.pop()

    // Em um novo array justamos titulo e erros
    let arr3 = [...arr1, ...arr2]

    // Verificamos se algum item é uma string vazia e o removemos
    arr3.forEach((item, index) => {
      if (item == ' ') arr3.splice(index, 1)
    })

    return arr3
  }
}

export default ErrorsObitoHelper
